module.exports = __webpack_public_path__ + "img/UrbanMining@2x.fde5744.jpg";